import * as React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Picking from '../../components/Picking'
import * as rubroActions from '../../reducers/rubrosReducer/actions'
import { usuarioSelector } from '../../selectors/sessionSelector'
import { loadingSelector } from '../../selectors/layoutSelector'
import { subrubrosPickingSelector } from '../../selectors/rubrosSelector'

class PickingContainer extends React.Component {

    constructor(props) {
        super(props)
        this.state= {
            usuarioCargado: false
        }

        //
        this.props.sagaGetSubRubrosPicking();
    }

    componentDidUpdate = () => {
        if(this.state.usuarioCargado === false && this.props.usuario !== undefined){
            this.setState({usuarioCargado: true}, () => {
                if(this.props.usuario.idRol === 4){
                    window.location.hash = '/Pedidos'
                }
            })
        }
    }

    handleOnSwap = (from, to) => {
        this.props.swapSubRubrosPicking(from, to)
    }

    render() {
        return (
            <Picking
                subRubros={this.props.subrubros} 
                handleOnSwap={this.handleOnSwap}
                loading={this.props.loading}
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
        ...rubroActions
	}, dispatch)
}

function mapStateToProps(state) {
	return {
        usuario: usuarioSelector(state),
        subrubros: subrubrosPickingSelector(state),
        loading: loadingSelector(state),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(PickingContainer)